import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import Pinjaman from "../views/Pinjaman.vue";
// import Pendanaan from "../views/Pendanaan.vue";
import TentangKami from "../views/TentangKami.vue";
import HubungiKami from "../views/HubungiKami.vue";
import SyaratKetentuan from "../views/SyaratKetentuan.vue";
// import BlogList from "../views/BlogList.vue";
// import BlogDetail from "../views/BlogDetail.vue";
import PageNotFound from "../views/PageNotFound.vue";
import EmailSuccess from "../views/EmailSuccess.vue";
// import Career from "../views/Career.vue";
// import DetilProduk from "../views/DetilProduk.vue";
// import Produk from "../views/Produk.vue";
import InformasiLainnya from "../views/InformasiLainnya.vue";
import InformasiLainnyaDetail from "../views/InformasiLainnyaDetail.vue";
// import Lpse from "../views/Lpse.vue";
// import Pengajuan from "../views/Pengajuan.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/pinjaman",
  //   name: "Pinjaman",
  //   component: Pinjaman,
  // },
  // {
  //   path: "/produk",
  //   name: "Produk",
  //   component: {
  //     render(c) {
  //       return c("router-view");
  //     },
  //   },
  //   children: [
  //     //UserInfo component is rendered when /user/:id is matched
  //     { path: "", name: "Produk", component: Produk, props: true },
  //     {
  //       path: ":type/:id",
  //       name: "Detil",
  //       component: DetilProduk,
  //       props: true,
  //     },
  //   ],
  // },
  // {
  //   path: "/pendanaan",
  //   name: "Pendanaan",
  //   component: Pendanaan,
  // },
  {
    path: "/tentang-kami",
    name: "Tentang Kami",
    component: TentangKami,
  },
  // {
  //   path: "/career",
  //   name: "Karir",
  //   component: Career,
  // },
  {
    path: "/hubungi-kami",
    name: "Hubungi Kami",
    component: HubungiKami,
  },
  {
    path: "/syarat-ketentuan",
    name: "Syarat Ketentuan",
    component: SyaratKetentuan,
  },
  {
    path: "/informasi-lainnya",
    name: "Informasi Lainnya",
    component: InformasiLainnya,
  },
  {
    path: "/informasi-lainnya/:id",
    name: "Informasi Lainnya Detail",
    component: InformasiLainnyaDetail,
  },
  // {
  //   path: "/blogs",
  //   name: "Blog",
  //   component: BlogList,
  // },
  // {
  //   path: "/lpse",
  //   name: "LPSE",
  //   component: Lpse,
  // },
  // {
  //   path: "/pengajuan",
  //   name: "Pengajuan",
  //   component: Pengajuan,
  // },
  // {
  //   path: "/blog/:id",
  //   Name: "Blog Detail",
  //   component: BlogDetail,
  // },
  {
    path: "/email-success/:id",
    Name: "Verifikasi Email Berhasil",
    component: EmailSuccess,
  },
  {
    path: "*",
    Name: "Page Not Found",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
